<div class="container-fluid m-2">
  <h2><b>Admin Access Management</b></h2>
  <div class="row my-4">
    <div class="col-12 col-lg-2">
      <h4 class="text-muted">On Duty</h4>
      @for (onDuty of adminAccessList; track onDuty) {
        @if (onDuty.onDutyAccessCount > 0) {
          <app-admin-access-item [adminAccessItem]="onDuty" [companyAccessList]="companyAccessList" [isOnDuty]="true"></app-admin-access-item>
        }
      }

      <div class="d-grid gap-2 mb-3">
        <button class="btn btn-outline-secondary" (click)="openAddOnDutyAdminModal()"><i class="fas fa-plus mr-2"></i> Add admin</button>
      </div>

      <h4 class="text-muted">Admins</h4>
      @for (admin of adminAccessList; track admin) {
        <app-admin-access-item [adminAccessItem]="admin" [companyAccessList]="companyAccessList"></app-admin-access-item>
      }
    </div>
    <div class="col-12 col-lg-10">
      @if (companyAccessList != undefined && companyAccessList.length > 0) {
        <div>
          <app-admin-access-table [companyAccessList]="companyAccessList"></app-admin-access-table>
        </div>
      }
    </div>
  </div>
</div>
